







































import { Component, Mixins, Prop } from "vue-property-decorator";
import { InvoiceStatusMap } from "@/data/enums/invoice";
import { IInvoice } from "@/models/invoices";
import Context from "@/mixins/context";
import i18n from "@/i18n";

@Component
export default class InvoiceStatusMsg extends Mixins(Context) {
  // Props
  @Prop({ required: true })
  public readonly invoice!: IInvoice;

  @Prop({ default: false })
  public readonly showActions!: boolean;

  @Prop({ default: () => i18n.t("_.invoice") })
  public readonly object!: string;
  // Computed

  public get mappedStatus() {
    return InvoiceStatusMap(this.invoice, this.object);
  }
}
